export const API_URL = 'https://staging.groomur.com/api/v1';
